import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFailBig = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 120,
	height: 120,
	viewBox: "0 0 120 120",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M74.3691 44.2246C74.7618 43.9043 75.3408 43.9269 75.707 44.293C76.0731 44.6591 76.0957 45.2381 75.7753 45.6309L75.707 45.707L45.707 75.707C45.3164 76.0976 44.6834 76.0976 44.2929 75.707C43.9024 75.3165 43.9024 74.6835 44.2929 74.293L74.2929 44.293L74.3691 44.2246Z",
			fill: "#E14949"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M44.2927 44.293C44.6589 43.9269 45.2379 43.9043 45.6306 44.2246L45.7068 44.293L75.7068 74.293L75.7752 74.3692C76.0955 74.7619 76.0729 75.3409 75.7068 75.707C75.3407 76.0732 74.7617 76.0957 74.3689 75.7754L74.2927 75.707L44.2927 45.707L44.2244 45.6309C43.904 45.2381 43.9266 44.6591 44.2927 44.293Z",
			fill: "#E14949"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M104 60C104 35.6995 84.3005 16 60 16C35.6995 16 16 35.6995 16 60C16 84.3005 35.6995 104 60 104C84.3005 104 104 84.3005 104 60ZM106 60C106 85.4051 85.4051 106 60 106C34.5949 106 14 85.4051 14 60C14 34.5949 34.5949 14 60 14C85.4051 14 106 34.5949 106 60Z",
			fill: "#E14949"
		})
	]
});
export default SvgFailBig;
